import * as React from 'react';
import { PagedListingState, BaseRouteProps } from '../../interfaces';
import { Team, PagedData } from '../../models';
import { TeamDataService } from '../../services';
import { NavLink } from 'react-router-dom';
import { PagedDataGrid } from '../../components';
import { UserStore, FilterStore } from '../../stores';
import { inject, observer } from 'mobx-react';
import { computed } from 'mobx';

interface TeamListingProps extends BaseRouteProps<{}> {
    UserStore?: UserStore;
    FilterStore?: FilterStore;
}

interface TeamListingState extends PagedListingState<Team> {
    filteredOrgId: number;
}

@inject('UserStore', 'FilterStore') @observer
export class TeamListing extends React.Component<TeamListingProps, TeamListingState> {
    private teamDataService = new TeamDataService(this.props.notificationService);

    @computed get userRole() {
        return this.props.UserStore!.userInfo.userRole;
    }

    @computed get organization() {
        return this.props.UserStore!.userInfo.organization;
    }

    @computed get filteredOrganization() {
        return this.props.FilterStore!.organization;
    }

    @computed get userPermissions() {
        if (this.props.UserStore && this.props.UserStore.userLoaded && this.props.UserStore.userInfo.userPermissions) {
            return this.props.UserStore!.userInfo.userPermissions;
        }
        return [];
    }

    constructor(props: TeamListingProps) {
        super(props);

        this.state = {
            entities: [],
            pageProperties: {
                currentPage: 1,
                pageSize: 20,
            },
            sortProperty: {
                id: 'Name',
                sortAscending: true
            },
            filteredOrgId: -1
        };

        this.dataFunctionWrapper = this.dataFunctionWrapper.bind(this);
        this.deleteBinder = this.deleteBinder.bind(this);
    }

    private dataFunctionWrapper(page: number, newPage: number, pageSize: number, filter?: string, sortProperty?: string, sortDirection?: string) {
        // if (['organizationAdmin', 'manager', 'user'].includes(this.userRole)) {
        if (this.filteredOrganization) {
            this.setState({
                filteredOrgId: this.filteredOrganization.id
            });
            return this.teamDataService.getByOrganizationPaged(this.filteredOrganization, page, pageSize, filter, sortProperty, sortDirection).then((response: PagedData<Team>) => {
                this.updateState(newPage, response);
            });
        }
        var empty = new Promise((success, reject) => {
            var data = new PagedData<Team>();
            data.entities = [];
            return this.updateState(1, data);
        });

        return empty;
        //  else {
        //     return this.teamDataService.getAllPaged(page, pageSize, filter, sortProperty, sortDirection).then((response: PagedData<Team>) => {
        //         this.updateState(newPage, response);
        //     });
        // }
    }

    private updateState(pageNumber: number, data: PagedData<any>) {
        this.setState({
            entities: data.entities,
            pageProperties: Object.assign(
                {},
                this.state.pageProperties,
                {
                    currentPage: pageNumber,
                    recordCount: data.recordCount
                }
            )
        });
    }

    private delete(id: number) {
        const entity = this.state.entities.find(e => e.id === id);

        var confirmed = confirm(`Are you sure you want to delete ${entity!.name}`);

        if (confirmed) {
            this.setState({
                entities: this.state.entities.filter((team: Team) => {
                    return team.id !== entity!.id;
                })
            });
        }
    }

    private deleteBinder(id: number): ((event: React.MouseEvent<HTMLElement>) => void) {
        return this.delete.bind(this, id);
    }

    componentWillUpdate() {
        if (this.filteredOrganization && this.state.filteredOrgId !== this.filteredOrganization.id) {
            this.setState({
                filteredOrgId: this.filteredOrganization.id
            });
            this.forceUpdate();
        }
    }

    public render() {
        const { sortProperty, pageProperties, entities } = this.state;

        const listData = entities.map(entity => {
            return {
                'Name': entity.name,
                'Organization': entity.organization ? entity.organization.name : '',
                'ActionKey': entity.id
            };
        });

        const actionsColumn = ({ value }: any) => {
            return (
                <span>
                    <NavLink to={`/team/${value}`} className="btn btn-default">View</NavLink>
                </span>
            );
        };

        const columnDefs = [
            { id: 'Name' },
            { id: 'Organization' },
            { id: 'ActionKey', title: 'Actions', width: '88px', customComponent: actionsColumn, sortable: false }
        ];

        return (
            <div>
                {this.filteredOrganization && <div id={`organization-${this.filteredOrganization.id}`} />}
                <div className="content-header">
                    <div className="content-container">
                        <div className="row">
                            <div className="col-xs-7">
                                <div className="title">
                                Teams <span className="light">for </span>
                                <span>'{this.filteredOrganization ? this.filteredOrganization.name : ''}'</span>
                                </div>
                            </div>
                            <div className="col-xs-5 text-right">
                                {(['superAdmin', 'siteAdmin'].indexOf(this.userRole) > -1 || this.userPermissions.indexOf('createTeams') > -1) && <NavLink className="btn btn-primary" to={'/team/create'}>
                                    <span className="glyphicon glyphicon-plus" /> Create
                                </NavLink>}
                            </div>
                        </div>
                    </div>
                </div>

                <div className="content-body">
                    <div className="content-container">
                        <PagedDataGrid
                            entities={listData}
                            columns={columnDefs}
                            dataFunction={this.dataFunctionWrapper}
                            defaultSort={sortProperty}
                            pageProperties={pageProperties}
                            state={this.state.filteredOrgId}
                        />
                    </div>
                </div>
            </div>);
    }
}


// WEBPACK FOOTER //
// ./src/components/team/TeamListing.tsx